var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.elementId}},[_c('v-app',{staticClass:"gc-assistant",attrs:{"id":(_vm.elementId + "-app")}},[_c('div',{ref:"containerElement"},[_c('assistant-container',{attrs:{"steps":_vm.steps,"machine":_vm.machine}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }